import { useSyncExternalStore } from 'react';
import type { CollectionDetailRoutePort } from './collectionDetailRoute';

export function useCollectionDetailRoute(route: CollectionDetailRoutePort) {
  const selectedId = useSyncExternalStore(route.subscribe, route.read, () => undefined);
  return { selectedId, openDetail: route.open, closeDetail: route.close };
}
